import { Panel } from "components/Panel/Panel";
import {
  Community,
  getExtendedTags,
  getHoverText,
  getLinkIconPath,
} from "model/Community/Community";
import { PlainA } from "styles/elements";
import { EmptyGrowPanelText } from "styles/text";
import { compareAlphabetically } from "Utility";
import { CommunityTag } from "../CommunityTag/CommunityTag";
import {
  CommunityContainer,
  CommunityGridContainer,
  CommunityGridItem,
  Description,
  Icon,
  LinkIcon,
  LogoContainer,
  Name,
  NameLogoContainer,
  Tags,
  UnicodeIcon,
} from "./styles";

interface Props {
  communities: Community[];
}

export const CommunityGrid = ({ communities }: Props) => {
  if (communities.length === 0) {
    return (
      <Panel>
        <EmptyGrowPanelText>
          No Communities For The Selected Filter
        </EmptyGrowPanelText>
      </Panel>
    );
  }
  return (
    <CommunityGridContainer>
      {[...communities]
        .sort((a, b) => compareAlphabetically(a.name, b.name))
        .map((c) => (
          <Panel key={c.id} bottomMargin={false}>
            <PlainA
              href={c.link}
              target="_blank"
              title={getHoverText(c.linkType)}
            >
              <CommunityGridItem>
                <LinkIcon>
                  {c.linkType === "Discord" ? (
                    <Icon src={getLinkIconPath(c.linkType)} />
                  ) : (
                    <UnicodeIcon>&#x1F310;&#xfe0e;</UnicodeIcon>
                  )}
                </LinkIcon>
                <CommunityContainer>
                  <NameLogoContainer>
                    {/* <LogoContainer></LogoContainer> */}
                    <Name>{c.name}</Name>
                  </NameLogoContainer>
                  <Description>{c.description}</Description>
                  <Tags>
                    {getExtendedTags(c)
                      .slice(0, 5)
                      .map((t) => (
                        <CommunityTag key={t} tag={t} />
                      ))}
                  </Tags>
                </CommunityContainer>
              </CommunityGridItem>
            </PlainA>
          </Panel>
        ))}
    </CommunityGridContainer>
  );
};
